import $ from "cash-dom"

export default () => {
  const heroSubsection = $(".l-hero--subsection")
  if (!heroSubsection.length) return

  if (window.gb?.isOn("trust_copy_on_header_production")) return

  $("body").addClass("ab-test-trust-copy-on-header")
  heroSubsection.remove()
  $(".l-navigation__tagline").remove()
}
